<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="기본정보" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn
                  v-show="isOld && !disabled && editable"
                  :url="completeUrl"
                  :isSubmit="isComplete"
                  :param="nearAccident"
                  mappingType="PUT"
                  label="완료"
                  icon="check"
                  @beforeAction="completeNearAccident"
                  @btnCallback="completeCallback" 
                />
                <c-btn
                  v-if="isOld && !disabled && editable" 
                  label="삭제" icon="delete_forever" @btnClicked="remove" />
                <c-btn
                  v-show="!disabled && editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="nearAccident"
                  :mappingType="saveType"
                  label="저장"
                  icon="save"
                  @beforeAction="saveNearAccident"
                  @btnCallback="saveCallback" 
                />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                <c-text 
                  required
                  :editable="editable && !nearAccident.iimNearAccidentId" 
                  name="iimNearAccidentName" 
                  label="아차사고명"
                  v-model="nearAccident.iimNearAccidentName"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-text 
                  :editable="editable" 
                  :disabled="true"
                  name="iimNearAccidentNo" 
                  label="아차사고번호"
                  v-model="nearAccident.iimNearAccidentNo"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-multi-select
                  required
                  codeGroupCd="IIM_NEAR_KIND_CD"
                  :editable="editable"
                  :disabled="disabled"
                  :isArray="false"
                  itemText="codeName"
                  itemValue="code"
                  name="iimNearKindCds"
                  label="재해유형"
                  v-model="nearAccident.iimNearKindCds"
                >
                </c-multi-select>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-datepicker
                  required
                  :editable="editable"
                  type="datetime"
                  :disabled="disabled"
                  :minuteStep="10"
                  label="발생일시"
                  name="occurrenceDt"
                  v-model="nearAccident.occurrenceDt"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-process
                  required
                  :editable="editable"
                  :disabled="disabled"
                  label="공정"
                  name="processCd"
                  v-model="nearAccident.processCd"
                >
                </c-process>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-dept
                  type="edit"
                  label="부서"
                  name="occurrenceDeptCd"
                  v-model="nearAccident.occurrenceDeptCd">
                </c-dept>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-text 
                  :editable="editable"
                  :disabled="disabled"
                  name="occurenceLocation" 
                  label="발생가능장소"
                  v-model="nearAccident.occurrenceLocation"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
                <c-plant 
                  required
                  :disabled="disabled"
                  :editable="editable" 
                  type="edit" 
                  name="plantCd" 
                  v-model="nearAccident.plantCd" />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                <c-text 
                  :editable="editable"
                  :disabled="disabled"
                  name="openning" 
                  label="기인물"
                  v-model="nearAccident.openning"
                />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <c-textarea
                  :editable="editable"
                  :disabled="disabled"
                  :isCheck="true"
                  :rows="2"
                  label="아차사고사항개요"
                  name="overviewAccidentSituation"
                  v-model="nearAccident.overviewAccidentSituation"
                  @checkboxClick="checkboxClick"
                >
                </c-textarea>
              </div>
            </template>  
          </c-card>
        </div>
      </div>
    </q-form>      
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'nearRegisterInfo',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        iimNearAccidentId: '',
      }),
    },
    //nearRelationPicture의 사진을 props로 가져와서 저장
    attachInfo1: {
      type: Object,
      default: function() {
        return {
          isSubmit: '',
          taskClassCd: 'NEAR_FIRST_PICTURE',
          taskKey: '',
        }
      },  
    },
    attachInfo2: {
      type: Object,
      default: function() {
        return {
          isSubmit: '',
          taskClassCd: 'NEAR_SECOND_PICTURE',
          taskKey: '',
        }
      },  
    },
  },
  data() {
    return {
      nearAccident: {
        iimNearAccidentId: '',
        plantCd: '',
        iimNearAccidentNo: '',
        iimNearAccidentName: '',
        iimStatusNearCd: '',
        reportUserId: '',
        reportDt: '',
        iimNearKindCds: '',
        iimGradeCd: null,
        occurrenceDt: '',
        occurrenceLocation: '',
        occurrenceDeptCd: '',
        weatherCd: 'WC000001',
        emergencyMeasures: '',
        overviewAccidentSituation: '',
        occurrenceModeLargeCd: null,
        occurrenceModeSmallCd: null,
        directCause: '',
        indirectCause: '',
        openning: '',
        injurious: '',
        iimNearDiscernCds: null,
        iimNearFunctionCds: null,
        iimNearFeelCds: null,
        iimNearEquipCds: null,
        iimNearManageCds: null,
        processCd: '',
        frequencyRisk: '',
        strengthRisk: '',
        totalRisk: '',
        ramRiskAssessmentPlanId: '',
        bounty: 0,
      },
      occFirstItems: [],
      occSecItems: [],
      weatherItems: [],
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      editable: true,
      saveType: 'POST',
      isSave: false,
      isComplete: false,
      isApproval: false,
      saveUrl: '',
      detailUrl: '',
      deleteUrl: '',
      completeUrl: '',
    };
  },
  watch: {
    // 상세조회를 했을 때 대분류에 따른 중분류의 값을 가져오는 부분
    'nearAccident.occurrenceModeLargeCd'() {
      if (!this.nearAccident.occurrenceModeLargeCd) return;
      this.setSecondItems(this.nearAccident.occurrenceModeLargeCd)
    },
  },
  computed: {
    isOld() {
      return Boolean(this.nearAccident.iimNearAccidentId)
    },
    disabled() {
      return (this.editable && Boolean(this.nearAccident.iimStatusNearCd) && this.nearAccident.iimStatusNearCd === 'ISNC000002') || this.nearAccident.approvalStatusCd === 'ASC9999999';
    },
    approvalInfo() {
      return {
        sysApprovalRequestId: this.nearAccident.sysApprovalRequestId, // 결재요청번호
        /**
         * 결재상태코드
         * ASC0000001	결재중
         * ASC0000002	반려
         * ASC9999999	결재완료
         */
        approvalStatusCd: this.nearAccident.approvalStatusCd, 
        apprEditable: !this.disabled && this.popupParam.iimNearAccidentId, // 결재버튼 활성화 기준
        param: this.nearAccident, // 결재 param
        approvalUrl: transactionConfig.sop.iim.accident.near.complete.url, // 결재 url
        isApproval: this.isApproval, // 결재 submit
        approvalTypeCd: 'APTC000016', // 결재유형코드
        approvalParamValue: { // 결재상세화면 파라미터
          iimNearAccidentId: this.popupParam.iimNearAccidentId,
          isApprContent: true
        },
        approvalRequestName: '아차사고 ['+this.nearAccident.iimNearAccidentName+']', // 결재요청명 (문서 title)
        approvalConnId: this.popupParam.iimNearAccidentId, // 결재연결용 업무일련번호 (문서 key)
      }
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sop.iim.accident.near.get.url;
      this.occurUrl = selectConfig.sop.iim.occurForm.list.url;
      this.saveUrl = transactionConfig.sop.iim.accident.near.insert.url;
      this.deleteUrl = transactionConfig.sop.iim.accident.near.delete.url;
      this.completeUrl = transactionConfig.sop.iim.accident.near.complete.url;
      // code setting
      this.setFirstItems();
      // list setting
      this.getDetail();
    },
    getDetail() {   //상세페이지 항목들에 저장된 값들을 가져오는 부분
      if (this.popupParam.iimNearAccidentId) {
        this.$http.url = this.$format(this.detailUrl, this.popupParam.iimNearAccidentId);
        this.$http.type = 'GET'; 
        this.$http.request((_result) => {
          this.nearAccident = _result.data;
          this.$set(this.attachInfo1, 'taskKey', this.popupParam.iimNearAccidentId)
          this.$set(this.attachInfo2, 'taskKey', this.popupParam.iimNearAccidentId)
          this.$emit('transInfo', _result.data);
        },);
      } else {
        // nothing...
      }
    },
    setFirstItems() {
      this.$http.url = this.occurUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        useFlag: 'Y',   //사용중인 것만 가져옴
        occurLevel: '1',  //발생레벨(깊이)
      }
      this.$http.request((_result) => {
        this.$_.forEach(_result.data, _item => {
          this.occFirstItems.splice(0, 0, {
            code: _item.iimOccurMasterId,   //목록을 가져오는 부분
            codeName: _item.occurName,      //가져온 목록의 이름을 넣는 부분
          })
        })
      },);
    },
    setSecondItems(iimOccurMasterId) {
      this.$http.url = this.occurUrl; 
      this.$http.type = 'GET';
      this.$http.param = {
        iimUpOccurMasterId: iimOccurMasterId,
        useFlag: 'Y',
        occurLevel: '2',
      }
      this.$http.request((_result) => {
        this.occSecItems = []; 
        this.$_.forEach(_result.data, _item => {
          this.occSecItems.splice(0, 0, {
            code: _item.iimOccurMasterId,
            codeName: _item.occurName,
          })
        })
      },);
    },
    dataChange() {  //유효성체크(숫자만 들어오게)
      if(this.nearAccident.frequencyRisk !== null && this.nearAccident.frequencyRisk >= 0 && this.nearAccident.strengthRisk !== null && this.nearAccident.strengthRisk >= 0) {
      this.nearAccident.totalRisk = this.nearAccident.frequencyRisk * this.nearAccident.strengthRisk
      }
    },
    saveNearAccident() {
      if (this.popupParam.iimNearAccidentId) {
        this.saveUrl = transactionConfig.sop.iim.accident.near.update.url;
        this.saveType = 'PUT';
      } else {
        this.saveUrl = transactionConfig.sop.iim.accident.near.insert.url;
        this.saveType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.nearAccident.regUserId = this.$store.getters.user.userId
              this.nearAccident.chgUserId = this.$store.getters.user.userId   
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (!this.popupParam.iimNearAccidentId) {
        this.$emit('changeStatus')  //개선관리 탭을 추가하는 부분(Detail -> RegisterTab -> RegisterInfo 순으로 되어있음)
        this.popupParam.iimNearAccidentId = result.data;
        // 관련사진에 사진을 저장하는 부분(없으면 상세조회 때 사진을 가져올 수 없음)
        this.$set(this.attachInfo1, 'taskKey', result.data)
        this.$set(this.attachInfo2, 'taskKey', result.data)
        this.$set(this.attachInfo1, 'isSubmit', uid())
        this.$set(this.attachInfo2, 'isSubmit', uid())
      }
      this.getDetail();
    },
    completeNearAccident() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '완료하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.nearAccident.regUserId = this.$store.getters.user.userId
              this.nearAccident.chgUserId = this.$store.getters.user.userId
              this.isComplete = !this.isComplete
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      // 완료버튼을 눌러서 완료한 뒤 ISNC000002(등록완료)를 전달하는 부분
      this.$emit('changeComplete')
      this.getDetail();
    },
    remove() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.iimNearAccidentId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup')
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    occurDataChange() {
      if (!this.nearAccident.occurrenceModeLargeCd){
        this.nearAccident.occurrenceModeSmallCd = null;
        this.occSecItems = [];
      } else {
        this.nearAccident.occurrenceModeSmallCd = null;
        this.setSecondItems(this.nearAccident.occurrenceModeLargeCd)
      }
    },
    checkboxClick(checkValue) {
      if (checkValue === 'O') {
        this.nearAccident.overviewAccidentSituation = 
          '- ' +
          '누가 : \n' + // 누가
          '- ' +
          '누구에게 : \n' + // 누구에게
          '- ' +
          '언제 : \n' + // 언제
          '- ' +
          '어디서 : \n' + // 어디서
          '- ' +
          '무엇을 : \n' + // 무엇을
          '- ' +
          '어떻게 : \n' + // 어떻게
          '- ' +
          '왜 : ';
      } else {
        this.nearAccident.overviewAccidentSituation = '';
      }
    },
  }
};       
  </script>